import { Text } from '@chakra-ui/react';

import data from './data.json';

const Title = () => (
  <Text as="h2" size="h2" whiteSpace="pre-wrap" gridColumn="span 12">
    {data.problem.title}
  </Text>
);

const Description = () => (
  <Text size="body2" position="relative">
    {data.problem.description}
  </Text>
);

export const Problem = { Title, Description };
